module.exports = __webpack_public_path__ + "img/redesim-ba.28adf5d3.png";